export default __webpack_public_path__ + "static/cyborg-cultur-preview-dc7fbcaa9f6388bd39fb31beb7cb50dd.png";